export const SUPPORTED_CURRENCIES = ['CLP', 'USD', 'MXN', 'EUR'] as const;
export type CurrencyCode = typeof SUPPORTED_CURRENCIES[number];

export interface RestaurantCurrencyResponse {
  restaurantId: number;
  countryId: number;
  baseCurrency: CurrencyCode;
  supportedCurrencies: CurrencyCode[];
}

export interface ExchangeRateQuoteResponse extends RestaurantCurrencyResponse {
  targetCurrency: CurrencyCode;
  rate: number;
  updatedAtUtc: string;
  nextUpdateAtUtc: string;
  isStale: boolean;
  source: string;
  attributionUrl: string;
}

export interface CurrencyDisplayState {
  restaurantId: number | null;
  baseCurrency: CurrencyCode | null;
  selectedCurrency: CurrencyCode | null;
  requestedCurrency: CurrencyCode | null;
  rate: number;
  loading: boolean;
  isStale: boolean;
  updatedAtUtc: string | null;
  nextUpdateAtUtc: string | null;
  source: string | null;
  attributionUrl: string | null;
  error: string | null;
}

export const CURRENCY_OPTIONS: ReadonlyArray<{ code: CurrencyCode; label: string }> = [
  { code: 'CLP', label: 'CLP — Peso chileno' },
  { code: 'USD', label: 'USD — Dólar estadounidense' },
  { code: 'MXN', label: 'MXN — Peso mexicano' },
  { code: 'EUR', label: 'EUR — Euro' }
];
